import React from 'react';
import Contact, { IContactInformation } from './contact/Contact';

import './body.scss';

const Body: React.FC<{
    admin?: IContactInformation;
    dealerLine?: IContactInformation;
}> = ({ admin, dealerLine }) => {
    return (
        <div className={'contact-info-body'}>
            {admin ? <Contact contactInformation={admin} /> : null}
            {dealerLine ? <Contact contactInformation={dealerLine} /> : null}
        </div>
    );
};

export default Body;
